import * as yup from "yup";

import { Translations, i18n } from "@i18n";
import { NameFormValues } from "./types";

export const validationSchema: yup.SchemaOf<NameFormValues> = yup.object().shape({
  firstName: yup.string().required(i18n.t(Translations.NameRouteFirstNameInputRequired)),
  lastName: yup.string().required(i18n.t(Translations.NameRouteLastNameInputRequired)),
});
